import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import './Add_User.css';
import Footer from './Footer.js';  // Import Footer component
import { useNavigate, useParams } from 'react-router-dom'; // useParams to get the dynamic id
import { BASE_URL } from './Constants'; // Import BASE_URL

const Get_DressSize = () => {
  const [dressTypes, setDressTypes] = useState([]);
  const [newUser, setNewUser] = useState({
    dress_size: '', // Add dress_type to state to bind it with the input
    type_id: '',
  gender: ''
  });
  const [formError, setFormError] = useState(null);
  const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate(); // Use navigate hook
  const { id } = useParams(); // Get dynamic id from the URL
useEffect(() => {
    const fetchDressTypes = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_types`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const data = await response.json();
        console.log('Fetched dress types:', data);

        if (data && data.dressTypes && Array.isArray(data.dressTypes)) {
          // Filter out dress types with status 'A'
          const activeDressTypes = data.dressTypes.filter(type => type.status === 'A');
          setDressTypes(activeDressTypes); // Set active dress types
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDressTypes();
  }, []); // Only runs once when the component mounts
  // Fetch dress type data based on ID when the component mounts
  useEffect(() => {
    const fetchDressType = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${BASE_URL}get_dress_sizes/${id}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch dress size');
        }

        const data = await response.json();
        // Use a functional update to avoid relying on newUser in the dependency array
        setNewUser(prevState => ({
          ...prevState,
          dress_size: data.dressSize.dress_size || '', // Populate the form with the fetched data
           type_id: data.dressSize.dress_type_id || '',
            gender: data.dressSize.gender || ''
        }));
      } catch (err) {
        setFormError(err.message);
      }
    };

    fetchDressType();
  }, [id]); // Only depend on id, not newUser

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple form validation
    if (!newUser.dress_size) {
      setFormError('field are required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('dress_size', newUser.dress_size);
      formData.append('dress_type', newUser.type_id);
      formData.append('gender', newUser.gender);
      

      const response = await fetch(`${BASE_URL}update_dress_sizes/${id}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.status) {
        throw new Error('Failed to add dress size');
      }

      // Redirect to the Manage User page after successful submission
      navigate('/manage_dresssize'); // You can modify this route if needed

    } catch (err) {
      setFormError(err.message);
    }
  };

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };
  const handleCancel = () => {
    navigate('/manage_dresssize');
  }
  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container" style={{
        marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
        transition: 'margin-left 0.3s ease',
        
      }}>
      <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen}/>
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  {/* Add User Card */}
                  <div className="card add-user-card">
                    <div className="card-header">
                      <h2>Edit Dress Size</h2>
                    </div>
                    <div className="card-body">
                      {/* Add User Form */}
                      <form onSubmit={handleSubmit}>
                        {formError && <div className="alert alert-danger">{formError}</div>}

                        <div className='form-group'>
                          <label>Gender</label>
                          <select
                            name="gender"
                            value={newUser.gender}
                            onChange={handleInputChange}
                            className='form-control'
                            required
                          >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>

                        <div className="form-group">
                          <label>Dress Type</label>
                          <select
                            name="type_id"
                            className="form-control"
                            value={newUser.type_id}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select Type</option>
                            {dressTypes.map((type) => (
                              <option key={type.id} value={type.id}>{type.dress_type}</option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group">
                          <label htmlFor="dress_size">Dress Size</label>
                          <input
                            type="text"
                            id="dress_size"
                            name="dress_size"
                            className="form-control"
                            value={newUser.dress_size}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                            Cancel
                          </button>
                          </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer /> {/* Footer will stick to the bottom */}
      </div>
    </div>
  );
};

export default Get_DressSize;
